module.exports = __webpack_public_path__ + "img/ico_profile.svg";